import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import {
  formatTicketClass,
  type TicketClassInput,
} from '@/helpers/ticketClass';
import { useTagTitles } from '@/hooks/useTagTitles';

export const useTicketClassLabel = (): ((
  ticket: TicketClassInput,
) => string) => {
  const { formatMessage } = useIntl();
  const tagTitles = useTagTitles();

  return useCallback(
    (ticket: TicketClassInput) => {
      const label = formatTicketClass(ticket, tagTitles);

      return (
        label || formatMessage({ defaultMessage: 'Ingen biljettyp tilldelad' })
      );
    },
    [tagTitles, formatMessage],
  );
};
